export const registerDocumentHeadElements = () => {
  const href = 'https://use.typekit.net/hxp6xfz.css';

  const existingLink = document.querySelector(`link[rel="stylesheet"][href="${href}"]`);

  if (!existingLink) {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;

    document.head.appendChild(link);
  }
};
